var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedalBronze(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Medal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bronze"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 1.1547C15.2376 0.44017 16.7624 0.44017 18 1.1547L27.8564 6.8453C29.094 7.55983 29.8564 8.88034 29.8564 10.3094V21.6906C29.8564 23.1197 29.094 24.4402 27.8564 25.1547L18 30.8453C16.7624 31.5598 15.2376 31.5598 14 30.8453L4.14359 25.1547C2.90599 24.4402 2.14359 23.1197 2.14359 21.6906V10.3094C2.14359 8.88034 2.90599 7.55983 4.14359 6.8453L14 1.1547Z",
    fill: "url(#paint0_radial_18323_9029)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 2.02073C15.4282 1.48483 16.5718 1.48483 17.5 2.02073L27.3564 7.71132C28.2846 8.24722 28.8564 9.2376 28.8564 10.3094V21.6906C28.8564 22.7624 28.2846 23.7528 27.3564 24.2887L17.5 29.9793C16.5718 30.5152 15.4282 30.5152 14.5 29.9793L4.64359 24.2887C3.71539 23.7528 3.14359 22.7624 3.14359 21.6906V10.3094C3.14359 9.2376 3.71539 8.24722 4.64359 7.71132L14.5 2.02073Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_18323_9029",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.3333 12) rotate(82.4054) scale(20.177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7875F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#824823"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalBronze);
export default __webpack_public_path__ + "static/media/medal-bronze.a6955e6702f7dec1df13f14b1ffe4fc2.svg";
export { ForwardRef as ReactComponent };